// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XBtjbuNODhLLZaYoeLx9{padding:12px}.RZT4pFB09CwRLPaeztSu{padding-top:12px;width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentWrapper": `XBtjbuNODhLLZaYoeLx9`,
	"contentWrapperSmall": `RZT4pFB09CwRLPaeztSu`
};
export default ___CSS_LOADER_EXPORT___;
